module.exports = __webpack_public_path__ + "img/asset_RAY-USDT.e6f46a11.png";